export default "__VITE_ASSET__CSfIxcyG__"